/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import LoadingOverlay from 'react-loading-overlay';
import AuthenticatedContext from '../../context/AuthenticatedContext';
import { backPageFlg, pageTitle } from '../../context/PageRecoil';
import { pathnames } from '../../api';
import useStyles from '../../css/style';
import DataDisp from './datadisp';
import { routeName } from '../../App';
import { requestEqTroubleDetail } from '../../api/eqTrouble';
import EqTrouble from '../../models/data/EqTrouble';
import useErrorHandling from '../errorCheck';

type UserPageParams = {
  eqid: string;
  id: string;
};

/**
 * 設備点検履歴画面
 */
const EqTroubleDetailPage: React.FunctionComponent = () => {
  const history = useHistory();
  const authContext = useContext(AuthenticatedContext); // ログインユーザの情報を取得
  const [backFlg, setBackFlg] = useRecoilState(backPageFlg);
  const classes = useStyles();
  const [loading, setLoading] = useState(true); // ロード画面の状態管理
  const { id, eqid } = useParams<UserPageParams>();
  const [data, setData] = useState<EqTrouble>(); // 表示するメインデータ
  const { errorCheck } = useErrorHandling(); // エラー処理

  const setPageTitle = useSetRecoilState(pageTitle);
  React.useEffect(() => {
    return setPageTitle({ pageTitle: '設備故障修理履歴詳細' }); // ページのタイトルを設定
  }, [setPageTitle]);

  // APIのURL
  const urlEqTroubleDetail = history.createHref({
    pathname: pathnames.eqTroubleDetail,
  }); // 設備故障履歴詳細取得

  // 初回画面表示時の処理
  useEffect(() => {
    setLoading(true); // 非同期処理前にsetLoading(true)
    Promise.all([
      requestEqTroubleDetail(urlEqTroubleDetail, {
        custEqId: Number(eqid),
        troubleEqId: Number(id),
      }),
    ])
      .then((responses) => {
        setData(responses[0].data); // 設備故障情報
      })
      .catch((error) => {
        errorCheck(error); // エラー内容を確認
      })
      .finally(() => {
        setLoading(false); // 非同期処理後にsetLoading(false)
      });
  }, []);
  return (
    <LoadingOverlay
      active={loading}
      className={classes.load}
      spinner
      text="データを読み込んでいます..."
    >
      <div className={classes.root}>
        <Button
          variant="primary"
          className="my-2"
          onClick={() => {
            setBackFlg({ ...backFlg, eqTroubleList: true });
            history.push(`${routeName.eqTroubleList}/${eqid}`);
          }}
        >
          戻る
        </Button>
        <br />
        <DataDisp userdata={authContext} data={data} />
      </div>
    </LoadingOverlay>
  );
};

export default EqTroubleDetailPage;
